import type { ReactNode } from 'react';

/**
 * One labelled band of the dashboard ("Kondycja spółki", "Ludzie", …). The
 * heading + one-line subtitle is what turns a wall of equal cards into a
 * readable story, so every top-level group on the page goes through this.
 * `action` sits opposite the heading (a link through to the detail page).
 */
export function DashboardSection({
  title,
  subtitle,
  action,
  children,
}: {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="flex flex-col gap-4">
      <div className="flex flex-wrap items-end justify-between gap-x-4 gap-y-1 border-b pb-2">
        <div className="min-w-0">
          <h2 className="text-base font-semibold tracking-tight">{title}</h2>
          {subtitle && <p className="text-muted-foreground text-xs">{subtitle}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
